// extracted by mini-css-extract-plugin
export default {"image":"background__image__QLL_k","color":"background__color__UTXqG","video":"background__video__lMuaJ","videoEnabled":"background__videoEnabled__I6Ozc"};